import { render, staticRenderFns } from "./ResetPage.vue?vue&type=template&id=9ae80472&scoped=true&"
import script from "./ResetPage.vue?vue&type=script&lang=js&"
export * from "./ResetPage.vue?vue&type=script&lang=js&"
import style0 from "./ResetPage.vue?vue&type=style&index=0&id=9ae80472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae80472",
  null
  
)

export default component.exports